import httpRequest from 'httpRequest'
import { LocationSetupContract } from 'models'

const ONSITE_SETUP_PREFIX = '/on-site-setup'

const onsiteSetupService = {
    postGenerateSetup: (locationTenantID: string) =>
        httpRequest.post<LocationSetupContract>(
            `${ONSITE_SETUP_PREFIX}/generate-setup-code`,
            {},
            { params: { locationTenantID: locationTenantID } },
        ),
    getToGetLocationSetups: () =>
        httpRequest.get<LocationSetupContract[]>(ONSITE_SETUP_PREFIX),
}

export default onsiteSetupService
